import ActionTypes from "../actions/actionTypes";
import logger from "../../utils/logger";


const initialState = {
  paymentSetups: [],
  hasPaymentSetup: false,
  loading: false,
  error: null,
  paymentSetupWallChecked: false,
};

const paymentSetupReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_PAYMENT_SETUPS:
      return {
        ...state,
        paymentSetups: action.payload,
        hasPaymentSetup: action.payload && action.payload.length > 0,
        error: null,
        paymentSetupWallChecked: true,
      };

    case ActionTypes.SET_PAYMENT_SETUP_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case ActionTypes.SET_PAYMENT_SETUP_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        paymentSetupWallChecked: true,
      };

    case ActionTypes.CLEAR_PAYMENT_SETUPS:
      logger.log("CLEAR_PAYMENT_SETUPS reducer executed");
      return {
        ...state,
        paymentSetups: [],
        hasPaymentSetup: false,
        error: null,
        loading: false,
        paymentSetupWallChecked: false,
      };

    case ActionTypes.SET_PAYMENT_SETUP_WALL_CHECKED:
      return {
        ...state,
        paymentSetupWallChecked: action.payload,
      };

    case ActionTypes.LOGOUT_USER:
      // Reset payment setup state on logout
      return initialState;

    default:
      return state;
  }
};

export default paymentSetupReducer;
